import type { ReactNode } from 'react'

type Props = {
  readonly children: ReactNode
}

export function MonitoringCards({ children }: Props) {
  return (
    <ul className="grid grid-cols-1 lg:grid-cols-3 gap-4 m-0 p-0 list-none">
      {children}
    </ul>
  )
}
